
export const authSelector = (state: any) => state.auth;

export const userSelector = (state: any) => state.auth?.user

export const tokenSelector = (state: any) => state.auth?.user?.token

export const notificationsSelector = (state: any) => state.auth?.user?.notifications;